// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-scrollbar[data-v-03b64e7b]{-ms-overflow-style:none;scrollbar-width:none}.no-scrollbar[data-v-03b64e7b]::-webkit-scrollbar{display:none}[id^=carousel-][data-v-03b64e7b]{scroll-behavior:smooth;scroll-snap-type:x mandatory}[id^=carousel-]>*[data-v-03b64e7b]{flex-shrink:0;scroll-snap-align:center;width:92%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
